import { GenericErrorDto } from './generic_error.dto';

export const handleGenericErrorEvent = (data: GenericErrorDto) => {
  const event = {
    event: data.event,
    event_params: {
      page_path: data.event_params.page_path,
      micrositio: data.event_params.micrositio ?? 'booking',
      page_type: data.event_params.page_type,
      homemarket: data.event_params.homemarket ?? 'chile',
      negocio: data.event_params.negocio ?? 'retail',
      buy_instance: data.event_params.buy_instance ?? 'IS',
      environment: data.event_params.environment ?? 'production',
    },
  };

  return event;
};
